export default class ResponseParser {
    static process(clientStater, msg) {
        clientStater.dispatch(msg.refGuid, msg);
    }
}
//# sourceMappingURL=responsePasrser.js.map